import { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";

export const MarkdownContent = ({
  text,
  className,
}: {
  text: string;
  className?: string;
}) => (
  <ReactMarkdown
    remarkPlugins={[remarkGfm]}
    rehypePlugins={[rehypeRaw, rehypeSanitize]}
    className={className}
    components={{
      p({ children }) {
        return (
          <p className="t-text-text-30 t-text-body-sm t-w-full last:t-mb-0 t-mb-2">
            {children}
          </p>
        );
      },
      a({ children, href }) {
        return (
          <a href={href} className="t-text-body-sm t-text-purple">
            {children}
          </a>
        );
      },
      ul({ children }) {
        return (
          <ul className="t-list-disc t-pl-4 t-text-body-sm t-text-text-30">
            {children}
          </ul>
        );
      },
      ol({ children }) {
        return (
          <ol className="t-list-decimal t-pl-4 t-text-body-sm t-text-text-30">
            {children}
          </ol>
        );
      },
    }}
  >
    {text}
  </ReactMarkdown>
);

export const RedeemInstructions = ({
  instructions,
}: {
  instructions?: string;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSeeMore = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsExpanded(true);
  };

  const handleSeeLess = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsExpanded(false);
  };

  return (
    <div className="t-text-text-30 t-text-body-sm t-w-full">
      {!isExpanded ? (
        <>
          <div className="t-line-clamp-2 t-overflow-hidden">
            <MarkdownContent text={instructions || ""} />
          </div>
          <span
            className="t-text-subtext-sm t-text-purple t-cursor-pointer"
            onClick={handleSeeMore}
          >
            See more
          </span>
        </>
      ) : (
        <>
          <MarkdownContent text={instructions || ""} />
          {isExpanded && (
            <span
              className="t-text-subtext-sm t-text-purple t-cursor-pointer t-ml-1"
              onClick={handleSeeLess}
            >
              See less
            </span>
          )}
        </>
      )}
    </div>
  );
};
